import * as ExcelJS from 'exceljs';
import React, { useRef, useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { DateStringFormat } from './dateUtil';

export const exportToXlsx = async (data, fileName,mHeaders, mObjData,fileName1) => {
    let orgData = JSON.parse(localStorage.getItem("orgName"));
    let OrgLocName = localStorage.getItem("orgLoc");
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    const firstRowStyle = {

        font: { bold: true, color: { argb: '181a18' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '4ae81e' } },
    };
    const conditionalStyle = { font: { bold: true }, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e8f005' } } }
    const conditionalStyle1 = { font: { bold: true }, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e8f005' } } }
    const orgDataRow = [orgData.text];
    const orgDataCell = worksheet.addRow(orgDataRow);
    orgDataCell.getCell(1).style = { font: { bold: true } };
    
    if(fileName1){
      const fileNameRow2 = [fileName1];
      const fileNameCell2 =worksheet.addRow(["Physical Location:", ...fileNameRow2]);
      fileNameCell2.getCell(1).style = { font: { bold: true} };
      fileNameCell2.getCell(2).style = { font: { bold: true} };
  }

    const fileNameRow = [fileName];
    const fileNameCell = worksheet.addRow(fileNameRow);
    fileNameCell.getCell(1).style = { font: { bold: false } };

    const headers = mHeaders?mHeaders: Object.keys(data[0]);
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell, colNumber) => {
        cell.style = firstRowStyle;
        worksheet.getColumn(colNumber).width = 15;
    });

    data.forEach((row, rowIndex) => {
        const dataRow = mObjData?mObjData.map(head => row[head]) : headers.map(head => row[head]);
        const newRow = worksheet.addRow(dataRow);
        if (row['Particular Name'] === 'Total' || row['Party Name'] === 'Party Total' ||row['Party Name'] === 'Invoice Total'||row['Party Name'] === 'Bill Total'|| row['Party Name'] === 'Grand Total'|| row['UOM'] === 'Total' || row['Particulars'] === "Total"||row["Salesman"] === "Total" ||row["Salesman"] === "Grand Total"
          || row["Location Name"] === "Status" || row["Sale Order Date"] === "No Of Orders" || row["Purchase Order Date"] === "No Of Orders"  || row["Item Code"] === "Total Value"|| row["Quantity Ordered"] 
          === "% of Total Value" || row["Physical Location"] === "Grand Total"
        ) {
            newRow.eachCell({ includeEmpty: true }, (cell) => { cell.style = conditionalStyle; });
        }
        if(row["Location Name"] === "Total"){
            newRow.eachCell({ includeEmpty: true }, (cell) => { cell.style = conditionalStyle1; });
        }
        
    });
    await workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName + '.xlsx';
        link.click();
    });
}


export const exportToPDF = (data, headerNames, fileName) => {
    const [unit, size, orientation, marginLeft] = ['pt', 'A4', 'landscape', 40]
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(10);
    let orgData = JSON.parse(localStorage.getItem("orgName"));
    const title = fileName;
    const headers = [headerNames];
    let content = {
        startY: 70,
        head: headers,
        body: data.map(item => Object.values(item))
    };
    doc.text(orgData.text, marginLeft, 45);
    doc.text(title, marginLeft, 60);
    doc.autoTable(content);
    doc.save(fileName + ".pdf");
}

export const exportTWOPartPDF = (data) =>{
    console.log('printData',data)
    const pdf = new jsPDF();
 
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const halfPageWidth = pageWidth / 2;
 
    // Divide the page into two parts
    pdf.setPage(1);
    // pdf.setProperties({
    //   pageSize: { width: pageWidth, height: pageHeight },
    // });
    // pdf.text('Table1', 0, halfPageWidth);
    pdf.autoTable({
        tableWidth: halfPageWidth,
        startY:10,
        margin: { left: halfPageWidth },
        avoidPageSplit: true,
        head:[['Liabilities','Amout']],
        body:data.array1.map(item => Object.values(item))

    })
    // pdf.setPage(1);
    // pdf.setProperties({
    //   pageSize: { width: halfPageWidth, height: pageHeight },
    // });
    // pdf.text('Table2',halfPageWidth, pageWidth);
    pdf.autoTable({
        tableWidth:halfPageWidth,
        // startY:10,
        margin: { left:0 },
        avoidPageSplit: true,
        head:[['Assets','Amout']],
        body:data.array2.map(item => Object.values(item))

    })
    // Add content to the first part
    // pdf.text(data.array1.join('\n'), 0, 5);
    // pdf.text(data.array2.join('\n'), halfPageWidth, 5);
    pdf.save('my-pdf.pdf');
} 

 

 
// export const MyComponent = ({ data }) => {
//   const generatePdf = () => {
//     const pdf = new jsPDF();
 
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();
//     const halfPageWidth = pageWidth / 2;
 
//     // Divide the page into two parts
//     pdf.setPage(1);
//     pdf.setProperties({
//       pageSize: { width: halfPageWidth, height: pageHeight },
//     });
//     pdf.text('Table1', 0, 5);
//     pdf.autoTable({
//         head:[['list','Amout']],
//         body:data.array1
//     })
 
//     // Add content to the first part
//     // pdf.text(data.array1.join('\n'), 0, 5);
//     // pdf.text(data.array2.join('\n'), halfPageWidth, 5);
//     // pdf.text(data.array3.join('\n'), 10,  10);
//     // pdf.text(data.array4.join('\n'), 30,  30);
//     // Move to the second part
//     // pdf.addPage();
//     // pdf.setProperties({
//     //   pageSize: { width: halfPageWidth, height: pageHeight },
//     //   rotation: 180,
//     // });
 
//     // // Add content to the second part
//     // pdf.text(data.array2.join('\n'), halfPageWidth - 10, pageHeight - 10);
 
//     // // Move to the third part
//     // pdf.addPage();
//     // pdf.setProperties({
//     //   pageSize: { width: halfPageWidth, height: pageHeight },
//     // });
 
//     // // Add content to the third part
//     // pdf.text(data.array3.join('\n'), 10, 10);
 
//     // // Move to the fourth part
//     // pdf.addPage();
//     // pdf.setProperties({
//     //   pageSize: { width: halfPageWidth, height: pageHeight },
//     //   rotation: 180,
//     // });
 
//     // // Add content to the fourth part
//     // pdf.text(data.array4.join('\n'), halfPageWidth - 10, pageHeight - 10);
 
//     // Save the generated PDF
//     pdf.save('my-pdf.pdf');
//   };
 
//   return (
//     <div>
//       <button onClick={generatePdf}>Generate PDF</button>
//     </div>
//   );
// };


 
export const MyComponent = () => {
  useEffect(() => {
    // Create a new jsPDF instance
    const doc = new jsPDF();
 
    // Sample data
    const data = [
      ['Name', 'Age', 'Country'],
      ['John Doe', 30, 'USA'],
      // ... more data ...
    ];
 
    // Define column headers and data
    const columns = ['Name', 'Age', 'Country'];
 
    // Set up autotable
    doc.autoTable({
      head: [columns],
      body: data,
      didDrawPage: (hookData) => {
        const totalPagesExp = '{total_pages_count_string}';
        const pageCount = doc.internal.getNumberOfPages();
        doc.text('Page ' + hookData.pageNumber + ' of ' + totalPagesExp, 10, 10);
 
        // Check if there's not enough space for the next table
        if (hookData.pageNumber < pageCount) {
          // Manually add a page
          doc.addPage();
        }
      },
    });
 
    // Save or display the document
    doc.save('table.pdf');
  }, []); // Run this effect only once on component mount
 
  return <div>Your component content goes here</div>;
};


 
